import { Input } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { addListingDetailsType } from '~addListing/types';
import { DAILY_DURATION } from '~addListing/utils/data';

const DailyPriceInput = () => {
  const { t } = useTranslation('app');

  const {
    setValue,
    watch,
    clearErrors,
    formState: { errors },
  } = useFormContext<addListingDetailsType>();

  const paymentPlans = watch('paymentPlans') || [];
  const isDailyExist = paymentPlans.find(
    (item) => item.duration === DAILY_DURATION,
  );
  const value = isDailyExist
    ? (paymentPlans.find((item) => item.duration === DAILY_DURATION)?.price ??
      '')
    : '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    const newValue = {
      price: Number(value.split(',').join('')) ?? '',
      duration: DAILY_DURATION,
    };
    const updatedPaymentPlans = paymentPlans.map((item) =>
      item.duration === DAILY_DURATION ? newValue : item,
    );
    setValue('paymentPlans', updatedPaymentPlans);
  };

  const hasErrors = errors.paymentPlans?.find?.(
    (item) => item?.price?.message === `${DAILY_DURATION}`,
  );

  const clearDailyErrors = () => {
    const errorIndex = errors.paymentPlans?.findIndex?.((item) => {
      return item?.price?.message === `${DAILY_DURATION}`;
    });

    if (errorIndex === -1) return;

    clearErrors(`paymentPlans.${Number(errorIndex)}.price`);
  };

  if (!isDailyExist) return null;

  return (
    <div className="flex flex-col gap-x">
      <div
        className={`${
          hasErrors ? 'border-red_dark' : 'border-gray'
        } flex gap-2x border  rounded-[12px] px-1.5x py-x items-center h-[40px] focus-within:border-blue_light_1 overflow-hidden`}
      >
        <Input
          field={{
            type: 'text',
            placeholder: t('rentDailyInputPlaceholder'),
            value: value ? value?.toLocaleString() : '',
            onChange: handleChange,
            onFocus: () => clearDailyErrors(),
            className: `${
              value ? 'text-gray__dark_2' : 'text-gray__dark_1'
            } flex-1 [&::-webkit-inner-spin-button]:appearance-none !px-0 !border-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]`,
          }}
          className="[&>div]:!border-none flex-1"
        />
        <div className="border-s ps-x border-gray text-body_2">
          <span className="text-gray__dark_2">
            {t('abbreviationEgyptianPound')} /{' '}
          </span>
          <span className="text-gray__dark_1">{t('day')}</span>
        </div>
      </div>
      {hasErrors && <p className="text-red_dark">{t('dailyPriceRequired')}</p>}
    </div>
  );
};

export default DailyPriceInput;
